import { render, staticRenderFns } from "./ListPI.vue?vue&type=template&id=33d1180c"
import script from "./ListPI.vue?vue&type=script&lang=js"
export * from "./ListPI.vue?vue&type=script&lang=js"
import style0 from "./ListPI.vue?vue&type=style&index=0&id=33d1180c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QTd,QChip,QPopupEdit,QBtn,QTooltip,QToolbar,QSelect,QSpace,QPagination});
